const phone = '+6285736907093'

export default {
  name: 'A Afif C',
  home: 'Surabaya, East Java, Indonesian',
  phone: {
    id: phone,
    view: '+62-857-36-9070-93'
  },
  email: 'aacassandra@programmer.net',
  socialLinks: [
    {
      icon: 'fab fa-linkedin-in',
      route: 'https://www.linkedin.com/in/aacassandra'
    },
    {
      icon: 'fab fa-github',
      route: 'https://github.com/aacassandra'
    },
    {
      icon: 'fas fa-laptop-house',
      route: 'https://projects.co.id/public/browse_users/view/6bf216/alauddin-afif-cassandra'
    },
    {
      icon: 'fab fa-whatsapp',
      route: `https://wa.me/6285736907093?text=Halo%20Afif%2C%20saya%20lihat%20profil%20kamu.`
    }
  ],
  fullname: 'Alauddin Afif Cassandra',
  jobs: ['Web Designer', 'Frontend Developer', 'Backend Developer', 'Mobile Hybrid Developer'],
  about: {
    me: 'Halo nama saya Alauddin Afif Cassandra, saya seorang programmer dari kota Surabaya, Indonesia. Saya lulusan jurusan statistika tahun 2015 dari Institut Teknologi Sepuluh Nopember. Saya lahir di kota Surabaya pada tanggal 3 Juni 1993. Hobi saya dari kecil membuat saya bisa menjadi seorang designer, analizer dan programmer, banyak hal yang telah saya lakukan selama ini tentang dunia informasi dan teknologi.',
    personalInfo: [
      {
        name: 'Residence',
        value: 'Indonesian'
      },
      {
        name: 'Age',
        value: '29 Years'
      },
      {
        name: 'Experience',
        value: '+6 Years'
      },
      {
        name: 'Email',
        value: 'aacassandra@programmer.net'
      },
      {
        name: 'Phone',
        value: '+62 8257 36 9070 93'
      },
      {
        name: 'Address',
        value: 'Surabaya, East Java, Indonesia.'
      }
    ],
    does: [
      {
        icon: 'lnr lnr-laptop-phone',
        title: 'Web Design',
        describtion:
          'Seperti yang Anda lihat sekarang, ini adalah salah satu situs web pribadi saya dengan desain yang elegan. begitu juga dengan pekerjaan saya yang lain, saya sangat memperhatikan design dalam bekerja'
      },
      {
        icon: 'lnr lnr-laptop',
        title: 'Frontend Developer',
        describtion:
          'Sebagian besar proyek saya adalah pengembangan sisi klien. Pengembangan sisi klien menjadi populer saat ini. Karena ada nodejs'
      },
      {
        icon: 'lnr lnr-database',
        title: 'Backend Developer',
        describtion:
          'Saya juga seorang pengembang backend, tetapi hanya dalam lingkup pengembangan web seperti menggunakan laravel, nodejs express, nuxtjs dan tidak lebih dari itu.'
      },
      {
        icon: 'lnr lnr-smartphone',
        title: 'Mobile Hybrid Developer',
        describtion:
          'Kemampuan saya juga untuk bisa mengembangkan mobile hybrid dengan performa tinggi yang hampir bisa mendekati aplikasi native'
      }
    ],
    testimonials: [
      {
        avatar: 'https://i.pravatar.cc/150?img=3',
        comment: 'worker berkompeten di bidangnya, sangat memuaskan',
        name: 'batikmadrim',
        city: 'Yogyakarta'
      },
      {
        avatar: 'https://i.pravatar.cc/150?img=14',
        comment: 'Terimakasih komunikatif dan sesuai dengan keinginan',
        name: 'hulioonly',
        city: 'Jakarta Timur'
      },
      {
        avatar: 'https://i.pravatar.cc/150?img=8',
        comment: 'mantap mas. terimakasih banyak atas bantuan nya.',
        name: 'hamzah27',
        city: 'Jakarta Barat'
      },
      {
        avatar: 'https://i.pravatar.cc/150?img=12',
        comment:
          'Terima kasih banyak ya mas bantuannya, Tolong bantuan support kedepannya ya mas. KOMUNIKASI lancar jaya.',
        name: 'vincent',
        city: 'Jakarta Utara'
      },
      {
        avatar: 'https://i.pravatar.cc/150?img=51',
        comment: 'Pekerjaan rapih dan luar biasa, terimakasih ya mas. REKOMMENDED!',
        name: 'Adrian',
        city: 'PT. Meratus Line (Surabaya Utara)'
      }
    ],
    clientLogos: [
      {
        src: '/img/clients/xl-axiata-bnw.webp',
        alt: 'XL Axiata',
        width: 190
      },
      {
        src: '/img/clients/meratusline-bnw.webp',
        alt: 'PT. Meratusline',
        width: 190
      },
      {
        src: '/img/clients/pci.webp',
        alt: 'PT. Platinum Ceramics Industry',
        width: 190
      },
      {
        src: '/img/clients/kanjuruhan.webp',
        alt: 'RSUD Kanjuruhan Kabupaten Malang',
        width: 190
      },
      {
        src: '/img/clients/kartustok-bnw.webp',
        alt: 'KartuStok',
        width: 150
      },
      {
        src: '/img/clients/dinas-pariwisata-kebudayaan-pasuruan-bnw.webp',
        alt: 'Dinas Pariwisata & Kebudayaan Pasuruan',
        width: 200
      },
      {
        src: '/img/clients/kopra-bnw.webp',
        alt: 'Koperasi Halmahera Maluku',
        width: 170
      },
      {
        src: '/img/clients/eci.webp',
        alt: 'Electronic City',
        width: 200
      },
      {
        src: '/img/clients/llm-bnw.webp',
        alt: 'Lembaga Lebuhraya Malaysia',
        width: 60
      },
      {
        src: '/img/clients/pos-system-bnw.webp',
        alt: 'POS System',
        width: 60
      },
      {
        src: '/img/clients/dinkes-gresik.webp',
        alt: 'POS System',
        width: 200
      },
      {
        src: '/img/clients/lnk.webp',
        alt: 'POS System',
        width: 230
      },
      {
        src: '/img/clients/sitepat.webp',
        alt: 'POS System',
        width: 200
      }
    ]
  },
  resume: {
    skills: {
      design: [
        {
          name: 'Web Design',
          percentage: 90
        },
        {
          name: 'Logo Design',
          percentage: 85
        }
      ],
      frontend: [
        {
          name: 'Angular Js',
          percentage: 65
        },
        {
          name: 'React Js',
          percentage: 80
        },
        {
          name: 'Vue Js',
          percentage: 95
        }
      ],
      backend: [
        {
          name: 'Laravel',
          percentage: 90
        },
        {
          name: 'Codeigniter',
          percentage: 60
        },
        {
          name: 'Nuxt Js',
          percentage: 90
        }
      ],
      mobile: [
        {
          name: 'Cordova',
          percentage: 90
        },
        {
          name: 'Ionic',
          percentage: 95
        },
        {
          name: 'React Native',
          percentage: 75
        }
      ],
      language: [
        {
          name: 'HTML/CSS',
          percentage: 95
        },
        {
          name: 'Javascript',
          percentage: 95
        },
        {
          name: 'PHP',
          percentage: 90
        }
      ],
      deployment: [
        {
          name: 'Heroku',
          percentage: 95
        },
        {
          name: 'Netlify',
          percentage: 95
        },
        {
          name: 'Vercel',
          percentage: 95
        },
        {
          name: 'Firebase Hosting',
          percentage: 95
        }
      ],
      os: [
        {
          name: 'Windows',
          percentage: 100
        },
        {
          name: 'Linux',
          percentage: 100
        },
        {
          name: 'Mac OS',
          percentage: 100
        }
      ]
    },
    knowledges: [
      'Programming',
      'Marketing',
      'Design',
      'Problem-Solving',
      'Time Management',
      'Communication',
      'Flexibility',
      'Data-Analitycs'
    ],
    education: [
      {
        name: 'D3 Statistic ITS, Surabaya, Indonesian.',
        years: '2011 - 2015',
        describtion:
          'Disini saya diajarkan tentang analisis data dan peramalan data, saya hanya memahami peramalan dan analisis data dasar. Dan itu juga berfungsi di bidang pekerjaan saya saat ini.'
      },
      {
        name: 'SMA Trimurti, Surabaya, Indonesian.',
        years: '2008 - 2011',
        describtion:
          'Ketika saya di sekolah menengah, saya mulai belajar desain menggunakan Adobe photoshop dan Corel Draw.'
      },
      {
        name: 'SMP Giki 3, Surabaya, Indonesian.',
        years: '2006 - 2008',
        describtion:
          'Disinilah hobi saya mulai berkembang, ketika saya masih duduk di bangku SMP, saya mulai belajar basic HTML dan basic design.'
      }
    ],
    experience: [
      {
        name: 'PT. QLCOM Solusi Bisnis Karir',
        as: 'Fullstack Web Developer',
        years: 'Jan 2022 - Current',
        describtion:
          'Disini saya bergabung ke team yang lebih besar dibandingkan company sebelumnya dan banyak ilmu baru yang saya dapatkan disini. Disini saya pernah menjadi project lead, dan sebagian menjadi backend atau frontend'
      },
      {
        name: 'PT. EYRO Digital Teknologi',
        as: 'Frontend & Mobile Hybrid Developer',
        years: 'Feb 2019 - Des 2021',
        describtion:
          'Sungguh luar biasa disini saya bergabung dengan tim yang profesional khususnya dibidang informatika. Di sini pengetahuan saya menjadi jauh lebih berkembang pesat.'
      },
      {
        name: 'PT. Wiratanu Persada Tama',
        as: 'Data Analizer & Mobile Hybrid Developer',
        years: 'Jun 2016 - Jan 2019',
        describtion:
          'Pengalaman kerja yang panjang di sini. Tidak jauh berbeda dengan pengalaman kerja saya disini bersama PT. Bank Mandiri. hanya saja disini saya mendapatkan banyak ilmu tentang informatika. Maka disini saya diberi tugas untuk membuat program Tripsheet Online.'
      },
      {
        name: 'PT. Bank Mandiri (Persero) Tbk',
        as: 'Data Analyzer, Thinker & Creative Doer',
        years: 'Jun 2015 - Jun 2016',
        describtion:
          'Pengalaman kerja nyata pertama saya di sini. Disini saya sebagai penganalisis data dan membuat alat untuk memonitor masalah mesin ATM, dimana alat tersebut diupdate secara otomatis selama 30 menit. Dengan kontribusi saya di sini, saya mendapatkan Bronze Certificate.'
      },
      {
        name: 'PT. Telekomunikasi Indonesia (Persero) Tbk',
        as: 'Data Analyzer',
        years: 'Jun 2013 - Jul 2013',
        describtion:
          'Ini adalah pengalaman kerja pertama saya, meskipun status saya di sini adalah sebagai magang. Tapi ini adalah langkah awal saya untuk mendapatkan pengalaman kerja yang tepat di perusahaan di sektor komunikasi terbesar di Indonesia.'
      }
    ]
  },
  portfolio: {
    categories: [
      {
        name: 'All',
        group: 'category_all',
        active: true
      },
      {
        name: 'Goverment',
        group: 'category_goverment',
        active: false
      },
      // {
      //   name: 'BUMN',
      //   group: 'category_bumn',
      //   active: false
      // },
      {
        name: 'Private Companies',
        group: 'category_private_companies',
        active: false
      },
      {
        name: 'Warehousing',
        group: 'category_warehousing',
        active: false
      },
      {
        name: 'Cooperative',
        group: 'category_cooperative',
        active: false
      },
      {
        name: 'E-Commerce',
        group: 'category_ecommerce',
        active: false
      },
      {
        name: 'ERP',
        group: 'erp',
        active: false
      },
      {
        name: 'IoT',
        group: 'category_iot',
        active: false
      }
    ],
    items: [
      {
        id: 'kGf8twV83nB',
        name: 'LLM',
        company: 'Lembaga Lebuhraya Malaysia',
        location: 'Kualalumpur, Malaysia',
        img: '/img/portfolio/llm.webp',
        status: 'Finished',
        screenshoots: ['/img/portfolio/full/llm-1.webp', '/img/portfolio/full/llm-2.webp'],
        category: ['category_all', 'category_goverment', 'category_iot'],
        createdAt: '2018-07-19 00:00:00',
        type: 'Backoffice',
        demoUrl: 'https://llm-ads-tracker.web.app',
        description:
          'Lembaga Lebuhraya Malaysia (LLM) adalah sebuah aplikasi untuk memantau papan reklame (billboard) dengan integrasi beacon. Dimana aplikasi ini juga berfungsi untuk mendeteksi tingkat segment pelanggan seperti umur, jenis kelamin, pendidikan dll. Disamping itu sistem ini juga tersedia untuk memantau masa tenggang papan reklame dan biaya sewa.',
        technologies: ['HTML5', 'CSS3', 'jQuery', 'Vue.js 2', 'SPA', 'Parse', 'Back4App']
      },
      {
        id: 'Vb1NtwZi3xL',
        name: 'Meratusline',
        company: 'PT. Meratus Line',
        location: 'Surabaya, Indonesia',
        img: '/img/portfolio/meratusline.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/meratusline-1.webp',
          '/img/portfolio/full/meratusline-2.webp',
          '/img/portfolio/full/meratusline-3.webp',
          '/img/portfolio/full/meratusline-4.webp',
          '/img/portfolio/full/meratusline-5.webp'
        ],
        category: ['category_all', 'category_private_companies'],
        createdAt: '2019-01-03 00:00:00',
        type: 'Landingpage & Backoffice',
        demoUrl: 'https://meratusline.com',
        description:
          'Sebuah landingpage untuk marketing strategi dan info karir dari perusahaan bidang shipping, dan juga berita terbaru mengenai perusahaan (blog). Dimana aplikasi ini sudah termasuk CMS untuk management kontent dan role management',
        technologies: ['HTML5', 'CSS3', 'jQuery', 'Vue.js 2', 'Laravel 6', 'MySQL']
      },
      {
        id: 'gHpLtKZi35p',
        name: 'Tingroom',
        company: 'PT. XL Axiata Tbk',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/xl-axiata.webp',
        status: 'Finished',
        screenshoots: ['/img/portfolio/full/xl-axiata-1.webp'],
        category: ['category_all', 'category_private_companies', 'category_iot', 'erp'],
        createdAt: '2018-02-29 00:00:00',
        type: 'Backoffice & WebOS TV',
        demoUrl: 'https://xl-tingroom-dev.herokuapp.com',
        description:
          'Adalah sebuah system management IoT, dimana Kanwil pusat atau tower XL memiliki ruang meeting yang banyak dengan adanya aplikasi ini, client bisa memesan ruang meeting dan melihat jadwal meeting yang terintegrasi dengan microsoft',
        technologies: ['HTML5', 'CSS3', 'jQuery', 'Vue.js 2', 'Laravel 5.8', 'MySQL', 'OneSignal']
      },
      {
        id: 'hgTtKoi30p',
        name: 'KOPRA',
        company: 'Koperasi Halmahera Maluku',
        location: 'Maluku, Indonesia',
        img: '/img/portfolio/kopra.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/kopra-1.webp',
          '/img/portfolio/full/kopra-2.webp',
          '/img/portfolio/full/kopra-3.webp',
          '/img/portfolio/full/kopra-4.webp',
          '/img/portfolio/full/kopra-5.webp',
          '/img/portfolio/full/kopra-6.webp'
        ],
        category: ['category_all', 'category_cooperative'],
        createdAt: '2019-05-17 00:00:00',
        type: 'Landingpage & Backoffice',
        demoUrl: null,
        description:
          'Sistem aplikasi yang dibuat untuk koperasi halmahera maluku, dimana ini bertujuan untuk bisnis sharing provit, bisa topup saldo untuk investasi project yang sedang berlangsung',
        technologies: ['HTML5', 'CSS3', 'jQuery', 'Laravel 5.8', 'MySQL']
      },
      {
        id: 'YeRgKo4u03',
        name: 'POS',
        company: 'Hulio POS',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/hulio-pos.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/hulio-pos-1.webp',
          '/img/portfolio/full/hulio-pos-2.webp',
          '/img/portfolio/full/hulio-pos-3.webp'
        ],
        category: ['category_all', 'category_private_companies', 'category_warehousing'],
        createdAt: '2019-05-17 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah sebuah aplikasi pergudangan untuk perusahaan tingkat menengah (Batu Bata), dengan adanya sistem aplikasi ini. Client jadi dimudahkan dalam mengelola stok dan sales.',
        technologies: ['HTML5', 'CSS3', 'jQuery', 'Laravel 7', 'Inertia.js', 'MySQL']
      },
      {
        id: 'Y71dB74u0z',
        name: 'VMS',
        company: 'Visitor Management Security',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/vms.webp',
        status: 'Skipped',
        screenshoots: [
          '/img/portfolio/full/vms-1.webp',
          '/img/portfolio/full/vms-2.webp',
          '/img/portfolio/full/vms-3.webp'
        ],
        category: ['category_all', 'category_private_companies', 'category_iot'],
        createdAt: '2020-08-17 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description: 'Sebuah aplikasi untuk memantau tamu yang sedang berkunjung ke kantor client.',
        technologies: [
          'HTML5',
          'CSS3',
          'jQuery',
          'Laravel 7',
          'Vue.js 3',
          'Parse',
          'Back4App',
          'SPA'
        ]
      },
      {
        id: 'uBRgKo4Xy8',
        name: 'ECI',
        company: 'PT. Electronic City Indonesia Tbk',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/eci.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/eci-1.webp',
          '/img/portfolio/full/eci-2.webp',
          '/img/portfolio/full/eci-3.webp',
          '/img/portfolio/full/eci-4.webp',
          '/img/portfolio/full/eci-5.webp',
          '/img/portfolio/full/eci-6.webp',
          '/img/portfolio/full/eci-7.webp',
          '/img/portfolio/full/eci-8.webp',
          '/img/portfolio/full/eci-9.webp',
          '/img/portfolio/full/eci-10.webp',
          '/img/portfolio/full/eci-11.webp',
          '/img/portfolio/full/eci-12.webp',
          '/img/portfolio/full/eci-13.webp',
          '/img/portfolio/full/eci-14.webp'
        ],
        category: ['category_all', 'category_private_companies', 'category_ecommerce'],
        createdAt: '2021-01-03 00:00:00',
        type: 'Landingpage & Backoffice',
        demoUrl: null,
        description:
          'Adalah sebuah aplikasi e-commerce, dimana e-commerce ini cuman menjual produk eletronik dan integrasi dgn paprika',
        technologies: ['HTML5', 'CSS3', 'Nuxt.js', 'Vue.js 3', 'PWA', 'MySQL']
      },
      {
        id: 'nMkd6tvuBh',
        name: 'KartuStok',
        company: 'KartuStok',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/kartustok.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/kartustok-1.webp',
          '/img/portfolio/full/kartustok-2.webp',
          '/img/portfolio/full/kartustok-3.webp',
          '/img/portfolio/full/kartustok-4.webp',
          '/img/portfolio/full/kartustok-5.webp',
          '/img/portfolio/full/kartustok-6.webp',
          '/img/portfolio/full/kartustok-7.webp'
        ],
        category: ['category_all', 'category_private_companies', 'category_warehousing'],
        createdAt: '2020-12-11 00:00:00',
        type: 'Android, iOS & Backoffice',
        demoUrl: null,
        description:
          'Adalah sebuah aplikasi pergudangan untuk perusahaan tingkat Startup, dengan adanya sistem aplikasi ini. Client jadi dimudahkan dalam mengelola stok.',
        technologies: ['HTML5', 'CSS3', 'Ionic 5', 'Vue.js 3', 'Capacitor.js 3', 'MySQL']
      },
      {
        id: 'pLyd8tvGBj',
        name: 'Mini POS',
        company: 'Mini POS',
        location: 'Jakarta, Indonesia',
        img: '/img/portfolio/minipos.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/minipos-1.webp',
          '/img/portfolio/full/minipos-2.webp',
          '/img/portfolio/full/minipos-3.webp',
          '/img/portfolio/full/minipos-4.webp',
          '/img/portfolio/full/minipos-5.webp',
          '/img/portfolio/full/minipos-6.webp',
          '/img/portfolio/full/minipos-7.webp'
        ],
        category: ['category_all', 'category_private_companies', 'category_warehousing'],
        createdAt: '2020-12-11 00:00:00',
        type: 'Android, iOS',
        demoUrl: null,
        description:
          'Adalah sebuah aplikasi pergudangan untuk perusahaan tingkat Startup, dengan adanya sistem aplikasi ini. Client jadi dimudahkan dalam mengelola stok. Aplikasi ini juga terintegrasi dengan scan barcode untuk input barang.',
        technologies: ['HTML5', 'CSS3', 'Ionic 5', 'Vue.js 3', 'Cordova.js 8', 'MySQL']
      },
      {
        id: 'ZopQgR74Ly2',
        name: 'SIMRS',
        company: 'RSUD Kanjuruhan Malang',
        location: 'Malang, Indonesia',
        img: '/img/portfolio/simrs.webp',
        status: 'On Progress',
        screenshoots: [
          '/img/portfolio/full/simrs-1.webp',
          '/img/portfolio/full/simrs-2.webp',
          '/img/portfolio/full/simrs-3.webp',
          '/img/portfolio/full/simrs-4.webp',
          '/img/portfolio/full/simrs-5.webp'
        ],
        category: ['category_all', 'category_goverment', 'erp'],
        createdAt: '2022-01-03 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu sistem teknologi informasi komunikasi yang memproses dan mengintegrasikan seluruh alur proses pelayanan Rumah Sakit dalam bentuk jaringan koordinasi, pelaporan dan prosedur administrasi untuk memperoleh informasi secara tepat dan akurat, dan merupakan bagian dari Sistem Informasi Kesehatan.',
        technologies: ['Laravel as Backend API', 'Vue.js 2 as Frontend', 'SPA', 'PostgreSQL']
      },
      {
        id: 'dKpQgRm4LSi',
        name: 'PCI',
        company: 'PT. Platinum Ceramics Industry',
        location: 'Surabaya, Indonesia',
        img: '/img/portfolio/pci.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/pci-1.webp',
          '/img/portfolio/full/pci-2.webp',
          '/img/portfolio/full/pci-3.webp',
          '/img/portfolio/full/pci-4.webp',
          '/img/portfolio/full/pci-5.webp',
          '/img/portfolio/full/pci-6.webp',
          '/img/portfolio/full/pci-7.webp'
        ],
        category: ['category_all', 'category_private_companies', 'erp'],
        createdAt: '2019-11-03 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan organisasi untuk meng-otomasi dan meng-integrasikan proses-proses bisnis utamanya',
        technologies: ['Laravel as Backend API', 'Vue.js 2 as Frontend', 'SPA', 'PostgreSQL']
      },
      {
        id: 'XmpJgRF2LSi',
        name: 'Dental',
        company: 'Jet- Z Dental Aesthetic Clinic',
        location: 'Surabaya, Indonesia',
        img: '/img/portfolio/dental.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/dental-1.webp',
          '/img/portfolio/full/dental-2.webp',
          '/img/portfolio/full/dental-3.webp',
          '/img/portfolio/full/dental-4.webp',
          '/img/portfolio/full/dental-5.webp',
          '/img/portfolio/full/dental-6.webp',
          '/img/portfolio/full/dental-7.webp',
          '/img/portfolio/full/dental-8.webp',
          '/img/portfolio/full/dental-9.webp',
          '/img/portfolio/full/dental-10.webp'
        ],
        category: ['category_all', 'category_private_companies', 'erp'],
        createdAt: '2019-11-03 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan organisasi untuk meng-otomasi dan meng-integrasikan proses-proses bisnis utamanya',
        technologies: ['Laravel', 'Vue.js 3', 'PostgreSQL']
      },
      {
        id: 'HKpQgZm9pSi',
        name: 'AMR Aware',
        company: 'AMR Aware',
        location: 'Surabaya, Indonesia',
        img: '/img/portfolio/amr.webp',
        status: 'On Progress',
        screenshoots: [
          '/img/portfolio/full/amr-1.webp',
          '/img/portfolio/full/amr-2.webp',
          '/img/portfolio/full/amr-3.webp',
          '/img/portfolio/full/amr-4.webp',
          '/img/portfolio/full/amr-5.webp',
          '/img/portfolio/full/amr-6.webp',
          '/img/portfolio/full/amr-7.webp'
        ],
        category: ['category_all', 'category_private_companies', 'erp'],
        createdAt: '2019-11-03 00:00:00',
        type: 'Landingpage & CMS',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan organisasi untuk meng-otomasi dan meng-integrasikan proses-proses bisnis utamanya',
        technologies: ['Parse Server as API', 'Nuxt 3 as Serverside', 'SPA', 'PWA', 'MongoDB']
      },
      {
        id: 'HKiKeZm9pSi',
        name: 'Pentas Sitepat',
        company: 'Dinas Pertanian Palembang',
        location: 'Palembang, Indonesia',
        img: '/img/portfolio/sitepat.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/sitepat-1.webp',
          '/img/portfolio/full/sitepat-2.webp',
          '/img/portfolio/full/sitepat-3.webp',
          '/img/portfolio/full/sitepat-4.webp',
          '/img/portfolio/full/sitepat-5.webp'
        ],
        category: ['category_all', 'category_goverment', 'erp'],
        createdAt: '2022-10-03 00:00:00',
        type: 'Landingpage & Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan organisasi untuk meng-otomasi dan meng-integrasikan proses-proses bisnis utamanya',
        technologies: ['Laravel 9', 'MySQL']
      },
      {
        id: 'HKpKg8m1pSi',
        name: 'Sistem Anggaran',
        company: 'Dinas Kesehatan Gresik',
        location: 'Gresik, Indonesia',
        img: '/img/portfolio/dinkes-gresik.webp',
        status: 'Finished',
        screenshoots: [
          '/img/portfolio/full/dinkes-gresik-1.webp',
          '/img/portfolio/full/dinkes-gresik-2.webp',
          '/img/portfolio/full/dinkes-gresik-3.webp',
          '/img/portfolio/full/dinkes-gresik-4.webp',
          '/img/portfolio/full/dinkes-gresik-5.webp',
          '/img/portfolio/full/dinkes-gresik-6.webp',
          '/img/portfolio/full/dinkes-gresik-7.webp',
          '/img/portfolio/full/dinkes-gresik-8.webp'
        ],
        category: ['category_all', 'category_goverment', 'erp'],
        createdAt: '2022-11-05 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan mengelola data realisasi tahunan dan bulanan',
        technologies: ['Laravel 9 as API Service', 'Nuxt 3 as Serverside', 'PostgreSQL', 'SPA']
      },
      {
        id: 'fQpKg2mvpSi',
        name: 'LNK Backoffice',
        company: 'PT. Lautan Natural Krimerindo',
        location: 'Mojokerto, Indonesia',
        img: '/img/portfolio/lnk.webp',
        status: 'On Progress',
        screenshoots: ['/img/portfolio/full/lnk-1.webp', '/img/portfolio/full/lnk-2.webp'],
        category: ['category_all', 'category_private_companies', 'erp'],
        createdAt: '2022-08-05 00:00:00',
        type: 'Backoffice',
        demoUrl: null,
        description:
          'Adalah suatu model sistem informasi yang memungkinkan organisasi untuk meng-otomasi dan meng-integrasikan proses-proses bisnis utamanya',
        technologies: ['React Js 17 as Frontend', 'Express Js as API Service', 'MongoDB']
      }
    ]
  }
}
